import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DecisioningStudioAgentWizard = lazy(() =>
  import("@scenes/OfferFit/components/DecisioningStudioAgentWizard").then((module) => ({
    default: module.DecisioningStudioAgentWizard,
  }))
);

export const decisioningStudioAgentWizardNRO: NavigationRoutingObject = {
  Component: DecisioningStudioAgentWizard,
  componentFeatureFlippers: ["decisioning_studio_wizard"],
  noKnockoutFallback: true,
  section: "offerfit",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("decisioning-studio-agent-wizard-nro-heading", "Configure BrazeAI Decisioning Studio™ Agent"),
  pageNameForTracking: () => "Configure BrazeAI Decisioning Studio™ Agent",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("decisioning-studio-agent-wizard-nro-description", "Configure a BrazeAI Decisioning Studio™ agent"),
  tag: "new",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission, isImpersonating }) => {
    if (!featureOn("decisioning_studio_wizard")) {
      return false;
    }

    const userCanEditDecisioningStudioAgents = hasPermission("appGroup", {
      permission: "editDecisioningStudioAgents",
    });

    return isImpersonating || userCanEditDecisioningStudioAgents;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/decisioning_studio/agents/:appGroupId",
};
